exports.defaultUserImage = 'https://freecodecamp.com/sample-image.png';
